import React from 'react'
import PropTypes from 'prop-types'
import { BeMessApiContext } from '../contexts/BeMessApiContext'
import { withApi, extractData } from './ApiProvider'
import { encodeParams } from '../helpers/encodeParams.js'

export const withBeMessApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <BeMessApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} beMessApi={value} />
        )}
      </BeMessApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withBeMessApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const BeMessApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const endpointsProvider = (baseURL) => {
    return {
      //  Generic
      getAllMessages: (idList, filterBy, orderBy, pageNum, pageSize) => (`${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams({ filterBy, orderBy, pageNum, pageSize })}`),
      getAllSms: (idList, filterBy, orderBy, pageNum, pageSize) => (`${baseURL}/list/${encodeURIComponent(idList)}/sms?${encodeParams({ filterBy, orderBy, pageNum, pageSize })}`),
      //  Manipulation
      getMessageLinks: (idMessage) => (`${baseURL}/message/${encodeURIComponent(idMessage)}/links`)
    }
  }

  const endpoints = endpointsProvider(process.env.BEMESS_URL)

  const getAllMessages = (idList, filterBy = '', orderBy = '', pageNum = 0, pageSize = 0) => {
    const url = endpoints.getAllMessages(idList, filterBy, orderBy, pageNum, pageSize)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getAllSms = (idList, filterBy = '', orderBy = '', pageNum = 0, pageSize = 0) => {
    const url = endpoints.getAllSms(idList, filterBy, orderBy, pageNum, pageSize)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getMessageLinks = (idMessage) => {
    const url = endpoints.getMessageLinks(idMessage)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const beMessApi = {
    getAllMessages,
    getAllSms,
    getMessageLinks
  }

  return (
    <BeMessApiContext.Provider value={beMessApi}>
      {children}
    </BeMessApiContext.Provider>
  )
}

BeMessApiProviderComponent.defaultProps = {
  children: null
}

BeMessApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const BeMessApiProvider = withApi(BeMessApiProviderComponent)
